import anchorScroll from './anchor-scroll.js';

export default anchorScroll;
